import controller from './tree-view-item-controller';

const TreeViewItemComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    isDivider: '<',
    expanded: '<',
    selected: '<',
    useUpdatedIcon: '<',
    icon: '<',
    key: '@',
    name: '@',
    disabled: '@',
    nodes: '<',
    onSelect: '&?',
    props: '<',
  },
  template: `
    <div class="tree-view-item"
         ng-if="!ctrl.isDivider"
         ng-class="{'has-children': ctrl.hasChildren(), 'is-leaf-selected': ctrl.selected}">
      <div class="item-actions">
        <a href="javascript://"
           class="item-turner"
           ng-class="{ 'is-closed': !ctrl.expanded }"
           ng-if="ctrl.hasChildren()"
           ng-click="ctrl.turn()"> </a>
      </div>
      <i ng-if="ctrl.icon && !ctrl.useUpdatedIcon" class="icon {{ ctrl.icon }}"></i>
      <capra-icon
        ng-if="ctrl.icon && ctrl.useUpdatedIcon"
        class="tree-view-capra-icon"
        ng-class="ctrl.isContinuous(ctrl.key) ? 'is-continuous' : 'is-discrete'"
        [icon]="ctrl.icon">
      </capra-icon>
      <div class="item-leaf"
           ng-class="{ 'is-selected': ctrl.selected }"
           ng-click="ctrl.hasChildren() ? ctrl.turn() : ctrl.select()">
        <span class="item-leaf-name" ng-bind="ctrl.name"></span>
      </div>
      <div class="item-branch"
           ng-if="ctrl.hasChildren()"
           ng-class="{ 'is-closed': !ctrl.expanded }">
        <tree-view
          nodes="ctrl.nodes"
          on-select="ctrl.handleChildTreeSelection($key)"/>
      </div>
    </div>
    <div class="divider" ng-if="ctrl.isDivider"></div>
  `,
};

export { TreeViewItemComponent };
